<template>
  <div>
    <el-divider>{{$t('表格列配置')}}</el-divider>
    <draggable :list="data.columns">
        <div class="learun-row-form-input" :key="item.id" v-for="(item, index) in data.columns">
            <el-form-item :label="$t('列名')">
                <el-input v-model="item.label" placeholder=""></el-input>
            </el-form-item>
            <el-form-item :label="$t('KEY')">
                <el-input v-if="data.dataType == 1" v-model="item.prop" placeholder=""></el-input>
                <l-select v-if="data.dataType == 3" 
                    v-model="item.prop"
                    :placeholder="$t('请选择')" 
                    size="mini" 
                    :options="myColNameList"
                    @change="handleDataSourceKeyLabelChange"
                >
                </l-select>
            </el-form-item>
            <el-form-item
                :label="$t('对齐')"
                >
                <l-select v-model="item.align" :options="alignOptions" />
            </el-form-item>
            <el-form-item :label="$t('列宽')">
                <el-input-number v-model="item.width"
                        controls-position="right"
                        :placeholder="$t('请输入列宽')"
                        :min="30"></el-input-number>
            </el-form-item>
            <el-form-item :label="$t('字段类型')">
                <l-field-type-select v-model="item.type" @change="$event => typeChange($event, item)"></l-field-type-select>
            </el-form-item>
            <!-- <el-form-item :label="$t('默认值')">
                <l-form-item v-if="item.type"
                    style="width: 100%" width="100%" 
                    v-model="item.value"
                    :data="{
                        ...getFilterFieldType(item.config),
                        mode: 'normal',
                        clearable: true}"></l-form-item>
            </el-form-item> -->
            <el-collapse class="field-box" v-if="item.type">
                <el-collapse-item :title="$t('字段属性')">
                    <component style="padding: 8px;" v-if="item.type" :is="`config-${item.config.type}`"
                            :data="item.config"></component>
                    <!-- <component v-if="item.type" :is="`field-${item.config.type}-config`" :data="item.config"></component> -->
                </el-collapse-item>
            </el-collapse>
            <!-- <el-form-item :label="$t('是否必填')">
                <el-switch v-model="item.required" placeholder=""></el-switch>
            </el-form-item> -->
            <el-form-item :label="$t('自动合并')">
                <el-switch v-model="item.autoMerge" placeholder=""></el-switch>
            </el-form-item>
            <el-form-item :label="$t('评分列')">
                <el-switch v-model="item.mark" placeholder=""></el-switch>
            </el-form-item>
            <el-form-item :label="$t('标准分列')">
                <el-switch v-model="item.common" placeholder=""></el-switch>
            </el-form-item>
            <el-form-item v-if="item.mark" :label="$t('关联评分人列')">
                <el-input v-if="data.dataType == 1" v-model="item.relateKey" placeholder=""></el-input>
                <l-select v-if="data.dataType == 3" 
                    v-model="item.relateKey"
                    :placeholder="$t('请选择')" 
                    size="mini" 
                    :options="myColNameList"
                    @change="handleDataSourceKeyLabelChange"
                >
                </l-select>
            </el-form-item>
            <el-button :title="$t('删除')" @click="data.columns.splice(index, 1);" class="learun-row-form-input-delete" circle
                plain size="mini" type="danger">
                <i class="el-icon-close"></i>
            </el-button>
        </div>
    </draggable>
    <div style="padding-left:22px;" >
        <el-button size="mini" type="text" icon="el-icon-circle-plus-outline" @click="addCol"  >{{$t('添加列')}}</el-button>
    </div>
    <el-divider>{{$t('考核数据')}}</el-divider>
    <div style="text-align: center;margin-bottom:16px;" >
        <el-radio-group v-model="data.dataType" size="mini" @change="handleDataTypeChange" >
            <el-radio-button label="1">{{$t('静态数据')}}</el-radio-button>
            <!-- <el-radio-button label="2">{{$t('数据字典')}}</el-radio-button> -->
            <el-radio-button label="3">{{$t('数据源')}}</el-radio-button>
            <!-- <el-radio-button label="4">{{$t('接口')}}</el-radio-button> -->
        </el-radio-group>
    </div>
    <!--静态数据-->
    <div v-if="data.dataType == 1" >
        <draggable
            :list="data.values">
            <div class="learun-row-form-input" :key="index" v-for="(item, index) in data.values">
                <div class="item flex" v-for="i in data.columns" :key="i.id">
                    <div class="label">
                        {{ i.label }}
                    </div>
                    <div style="flex: 1;">
                        <l-form-item v-if="i.type"
                        style="width: 100%" width="100%" 
                        v-model="item[i.prop]"
                        @change="setVal"
                        :data="{
                            ...getFilterFieldType(i.config),
                            mode: 'normal',
                            clearable: true}"></l-form-item>
                    </div>
                </div>
                <el-button :title="$t('删除')" @click="data.values.splice(index, 1);" class="learun-row-form-input-delete" circle
                plain size="mini" type="danger">
                    <i class="el-icon-close"></i>
                </el-button>
            </div>
        </draggable>
        <div style="padding-left:22px;" >
            <el-button size="mini" type="text" icon="el-icon-circle-plus-outline" @click="addValue"  >{{$t('添加考核数据')}}</el-button>
        </div>
    </div>
    <!--数据字典-->
    <!-- <div v-else-if="data.dataType == 2" >
        <l-tree-select
            v-model="data.dataCode"
            :options="dataItemClassifysTree"
            :placeholder="$t('请选择')"
            size="mini"
            :parent="false"

            @change="handleDataItemChange"
        >
        </l-tree-select>
    </div> -->
    <!--远端数据-->
    <div v-else-if="data.dataType == 3" >
        <el-form-item :label="$t('数据源')">
            <l-select  
                    v-model="data.dataCode"
                    :placeholder="$t('请选择')" 
                    size="mini" 
                    :options="dataSource" 
                    labelKey="f_Name" 
                    valueKey="f_Code"

                    @change="handleDataSourceChange"
                >
            </l-select>
        </el-form-item>
        <!-- <div v-if="data.ParamJsonList && data.ParamJsonList.length" style="margin-bottom: 10px;">参数</div>
        <currencyCustomSearch :ParamJsonList="data.ParamJsonList" @getList="getList" :showReset="false" :viewMode="true" ref="customSearch" :searchText="'刷新数据'"></currencyCustomSearch> -->
        <!-- <el-form-item :label="$t('值')">
            <l-select  
                    v-model="data.dataValueKey"
                    :placeholder="$t('请选择')" 
                    size="mini" 
                    :options="myColNameList" 

                    @change="handleDataSourceKeyLabelChange"
                >
            </l-select>
        </el-form-item>
        <el-form-item :label="$t('标签')">
            <l-select  
                    v-model="data.dataLabelKey"
                    :placeholder="$t('请选择')" 
                    size="mini" 
                    :options="myColNameList"
                    @change="handleDataSourceKeyLabelChange"
                >
            </l-select>
        </el-form-item>
        <el-form-item :label="$t('上一级')">
            <l-select
                v-model="data.upCtrl"
                :placeholder="$t('请选择')"
                size="mini"
                :options="componentOptions"
            >
            </l-select>
        </el-form-item> -->
        
    </div>
    <!-- <div v-else>
        <el-form-item :label="$t('接口地址')">
            <el-input
            size="mini"
            v-model="data.httpUrl"
            :placeholder="$t('请输入接口地址')"
            @change="changeURL"></el-input>
        </el-form-item>
        <el-form-item :label="$t('请求方式')">
            <l-select  
                v-model="data.httpWay"
                :placeholder="$t('请选择')" 
                size="mini" 
                :options="wayList"
                labelKey="label" 
                valueKey="value"
                @change="changeURL"
            >
            </l-select>
        </el-form-item>
        <el-form-item :label="$t('请求默认参数')">
            <el-input
            type="textarea"
            size="mini"
            v-model="data.params"
            :placeholder="$t('请输入请求默认参数')"
            @change="changeURL"></el-input>
        </el-form-item>
        <el-form-item :label="$t('搜索参数')">
            <el-input
            size="mini"
            v-model="data.remoteParams"
            :placeholder="$t('请输入请求参数')"
            @change="changeURL"></el-input>
        </el-form-item>
        <el-form-item :label="$t('关联组件ID')">
            <el-input
            type="textarea"
            size="mini"
            v-model="data.assemblyID"
            :placeholder="$t('请输入关联组件ID,多个逗号分隔')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('值')">
            <l-select  
                    v-model="data.dataValueKey"
                    :placeholder="$t('请选择')" 
                    size="mini" 
                    :options="myRemoteList" 

                    @change="handleDataSourceKeyLabelChange"
                >
            </l-select>
        </el-form-item>
        <el-form-item :label="$t('标签')">
            <l-select  
                    v-model="data.dataLabelKey"
                    :placeholder="$t('请选择')" 
                    size="mini" 
                    :options="myRemoteList"
                    @change="handleDataSourceKeyLabelChange"
                >
            </l-select>
        </el-form-item>
    </div> -->
  </div>
</template>

<script>
const requireComponent = require.context('./', true, /\.vue$/)
const myComponents = {}
requireComponent.keys().map(fileName => {
    const name = fileName.split('/')[1].split('.')[0]
    if(name != 'cascader'){
        myComponents[`config-${name}`] = requireComponent(fileName).default
    }
    
})
import mixin from '../../../mixin'
export default {
    name: "config-select",
    mixins: [mixin()],
    inject: ["formDesign"],
    props: ['data'],
    components:{
        ...myComponents
    },
    data () {
        return {
            wayList:[
                {label:'GET',value:'GET'},
                {label:'POST',value:'POST'},
                {label:'PUT',value:'PUT'},
                {label:'DELETE',value:'DELETE'},
            ],
            initColumn: {
                id: '',
                prop: '',
                label: '',
                type: '',  // 字段类型
                value: '', // 默认值
                config: {}, // 字段属性
                required: false,
                autoMerge: false, // 自动合并
                mark: false, // 评分列
                relateKey: '', // 关联评分人列
                align: 'left', // 对齐方式
                common: false, // 标准分列
            },
            alignOptions: [
                { value: "left", label: this.$t("靠左") },
                { value: "center", label: this.$t("居中") },
                { value: "right", label: this.$t("靠右") },
            ],
        }
    },
    created(){
        this.lr_loadDataItemClassifys && this.lr_loadDataItemClassifys()
        this.lr_loadDataSourceList && this.lr_loadDataSourceList()
        this.loadDataSourceCol()
    },
    computed:{
        dataItemClassifysTree(){
            if(this.lr_dataItemClassifysTree){
                return this.lr_dataItemClassifysTree
            }
            else{
                return []
            }
        },
        dataSource(){
            if(this.lr_dataSource){
                return this.lr_dataSource
            }
            else{
                return []
            }
        }
    },
    methods: {
        getViewData() {
            this.ParamJsonList.forEach(item => {
                let key = item.f_ParamName.slice(1)
                if (this.lr_dataParamsSource[item.f_DefaultValue]) {
                obj[key] = this.lr_dataParamsSource[item.f_DefaultValue]
                } else {
                if((item.f_DataType == 'date' || item.f_DataType == 'datetime') && item.f_NewDefaultValue){
                    obj[key] = item.f_NewDefaultValue
                }else if (item.f_DefaultValue) {
                    obj[key] = item.f_DefaultValue
                }
                }
            })
            let pamdata = {
                queryJson: obj
            }
            return this.lr_dataSourceDataByParamter[`${this.dataCode}_${JSON.stringify(pamdata)}`] || []
        },
        typeChange(val, row) {
            row.config = this.$deepClone(val);
            row.value = ''
        },
        addCol() {
            this.data.columns.push(Object.assign(this.$deepClone(this.initColumn), {
                id: this.$uuid()
            }))
        },
        addValue() {
            if (!this.data.columns.length) return this.$tip('请先配置列', 'warning')
            let arr = this.data.columns.map(e => e.prop)
            let obj = {}
            arr.forEach(e => obj[e] = '')
            this.data.values.push(obj)
        },
        setVal() {
            this.data.default = JSON.stringify(this.data.values)
        },
        changeURL(){
            if(this.data.httpWay&&this.data.httpUrl){
                console.log('进啦');
                this.lr_loadDataByURL(this.data.httpUrl,this.data.httpWay,this.data.params)
            }
        },
        handleDataTypeChange(){
            this.data.dataCode = '';
            this.data.dataValueKey = '';
            this.data.dataLabelKey = '';


            this.data.default = '';
            if (this.data.dataType !== 3) {
                this.data.seachLoopUp = false
            }
        },
        handleRemoveDatas(index){
            if(this.data.default == this.data.options[index].value){
                this.data.default = '';
            }
            this.data.options.splice(index,1);
        },

        handleDataItemChange(){
            this.data.default = ''
            if(!this.$validatenull(this.data.dataCode) && this.lr_loadDataItem){
                this.lr_loadDataItem(this.data.dataCode)
            }
        },
        handleDataSourceChange(data){
            this.data.default = ''
            let sql = data.f_Sql;
            const { columns, queryJson, sqls } = JSON.parse(sql);
            var obj = {}
            if (queryJson) {
                queryJson.forEach(item => {
                    item.disabled = item.f_DefaultValue ? item.f_DefaultValue.charAt(0) == '#' ? true : false : false
                    var bol = true
                    if(this.lr_dataParamsSource){
                      for(var i in this.lr_dataParamsSource){
                        if(i == item.f_DefaultValue){
                            obj[item.f_ParamName.slice(1)] = this.lr_dataParamsSource[i]
                            bol= false
                        }else{
                          if(bol){
                            if((item.f_DataType == 'date' || item.f_DataType == 'datetime') && item.f_NewDefaultValue){
                              obj[item.f_ParamName.slice(1)] = item.f_NewDefaultValue
                            }else{
                              obj[item.f_ParamName.slice(1)] = item.f_DefaultValue
                            }
                          }
    
                        }
                      }
                    }else{
                      if((item.f_DataType == 'date' || item.f_DataType == 'datetime') && item.f_NewDefaultValue){
                        obj[item.f_ParamName.slice(1)] = item.f_NewDefaultValue
                      }else{
                        obj[item.f_ParamName.slice(1)] = item.f_DefaultValue
                      }
                    }
                })
                this.data.ParamJsonList = queryJson
            } else {
                this.data.ParamJsonList = []
            }
            var pamdata = {
                queryJson:obj
            }
            if(!this.$validatenull(this.data.dataCode) && this.lr_loadDataSourceColNames){
                this.lr_loadDataSourceColNames(this.data.dataCode)
                this.lr_loadDataSourceDataByParamter(this.data.dataCode,pamdata, true, true)
                setTimeout(() => {
                    this.data.values = this.getViewData()
                    this.setVal()
                }, 1000);
            }
        },
        getList(list){
            this.data.dataValueKey = '';
            this.data.dataLabelKey = '';
            this.data.default = '';
            this.data.ParamJsonList = list
            var obj = {}
            list.forEach((item) => {
                var bol = true
                if(this.lr_dataParamsSource){
                    for(var i in this.lr_dataParamsSource){
                    if(i == item.f_DefaultValue){
                        obj[item.f_ParamName.slice(1)] = this.lr_dataParamsSource[i]
                        bol= false
                    }else{
                        if(bol){
                        if((item.f_DataType == 'date' || item.f_DataType == 'datetime') && item.f_NewDefaultValue){
                            obj[item.f_ParamName.slice(1)] = item.f_NewDefaultValue
                        }else{
                            obj[item.f_ParamName.slice(1)] = item.f_DefaultValue
                        }
                        }

                    }
                    }
                }else{
                    if((item.f_DataType == 'date' || item.f_DataType == 'datetime') && item.f_NewDefaultValue){
                    obj[item.f_ParamName.slice(1)] = item.f_NewDefaultValue
                    }else{
                    obj[item.f_ParamName.slice(1)] = item.f_DefaultValue
                    }
                }
            })
            var pamdata = {
                queryJson:obj
            }
            this.lr_loadDataSourceDataByParamter(this.data.dataCode,pamdata, true, true)
        },
        handleDataSourceKeyLabelChange(){
            this.data.default = ''
        }
    }
}
</script>
<style scoped lang="less">
.item {
    margin-bottom: 6px;
    .label {
        min-width: 100px;
        text-align: right;
        margin-right: 8px;
    }
}
::v-deep {
    .el-collapse-item__header, .el-collapse-item__wrap,.el-divider__text {
        background: #f5f5f5;
    }
}
</style>

